export default {
  home: {
    lang: '中文',
    lang_cn: 'Traditional Chinese',
    lang_en: 'English',
    form_title:'[Asia Coffee Music Festival x V23 First Debut | March 6-8]',
    form_title2:'Register now to receive the upcoming promotions and activities of iCAUR V23',
    submit:'Submit',
    mandatory:'Mandatory',
    yes:"Yes",
    no:"No",
    lastName:'Last name',
    firstName:'First name',
    enterLastName:'Please enter your last name',
    enterFirstName:'Please enter your first name',
    emailAddress:'Email address',
    enterEmail:'Please enter your email',
    rightEmail:'Please enter the correct email address!',
    contract:'Contract Number',
    rightContract:'Please enter the contract number',
    contractStartWithI:'Contract number must start with I',
    contractLength:'Contract number must be 5-8 characters',
    mobileNumber:'Mobile number',
    enterPhone:'Please enter your phone number',
    rightPhone:'Please enter the correct phone number!',
    privacyPolicy:"I/We agree with the use of my/our personal data by KLM,its affiliates, subsidiaries and associated companies for direct marketing purposes in accordance with the Personal Information Collection Statement and the Privacy Policy Statement.",
    appellation:'Title',
    selectAppellation:'Please select a title',
    corporateClient:'Corporate client',
    selectLanguage:'Select language',
    pleaseSelectLanguage:'Please select language',
    InformationSubmitted:'It has been submitted, thank you!',
    pleaseWriteName:'company name',
    pleaseWriteName_:'If so, please provide the company name',
    agree_:'I/We have read and agree to the',
    statement_:'Personal lnformation Collection Statement',
    policy_:'Privacy Policy Statement',
    and:' and ',
    corporateClient_:'Please select a corporate customer',
    _policy:'Please check “privacy policy”',
    remark:'Remark',
    fullStop:'.'
  },
  appellation: {
    Sir: 'Mr.',
    lady: 'Mrs.',
    Miss: 'Miss',
    professor: 'professor',
  },
  carOption: {
    cartitle: 'Preferred model',
    car1: 'V23 (RHD)',
    car2: 'V23 Sport (AWD)',
    carModel_:'Please select your preferred model'
  }
};

